import {MANUAL_AND_APP_LANGUAGE} from '../serve/consts';
import {get, set} from '../serve/localStorage';

export function setManualAndAppLanguage(language: string) {
  set(MANUAL_AND_APP_LANGUAGE, language);
}

export function getManualAndAppLanguage() {
  return get<string>(MANUAL_AND_APP_LANGUAGE);
}

export function hasManualAndAppLanguage() {
  return Boolean(getManualAndAppLanguage());
}
